import { createVNode as a, mergeProps as i } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/FileZipTwotoneStandard.js";
import p from "../components/PfIcon.js";
const t = (o, r) => {
  const e = {
    ...o,
    ...r.attrs
  };
  return a(p, i(e, {
    icon: n
  }), null);
};
t.displayName = "FileZipTwotoneStandard";
t.inheritAttrs = !1;
export {
  t as default
};
